<template>
  <header class="bg-dark border-bottom text-light py-2 mb-3">
    <div class="container d-flex justify-content-between">
      <a href="/">
        <img src="/assets/images/logo.png" alt="Logo" /> BÍBLIA BDN
      </a>
      <div>
<!--        <div class="btn-group mx-2" role="group">
          <template v-for="version in versions" :key="version">
            <input type="radio" class="btn-check" :id="version" :value="version" v-model="selectedVersion"
              @change="loadBooks" />
            <label class="btn btn-sm btn-outline-primary" :for="version">{{ version }}</label>
          </template>
        </div>
-->
        <button class="btn btn-sm bg-light" @click="toggleDarkMode">
          <i :class="isDarkMode ? 'fa-solid fa-sun' : 'fa-solid fa-moon'"></i>
        </button>
        <Navbar />
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue';
import Navbar from "@/components/Navbar";

const isDarkMode = ref(false);

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value;
  document.documentElement.setAttribute('data-bs-theme', isDarkMode.value);
};
</script>

<style scoped>
header img {
  width: 50px;
}</style>